import { gql, useLazyQuery } from "@apollo/client";
import {
  RouteAgreementsRatesByFilterQuery,
  RouteAgreementsRatesByFilterQueryVariables,
} from "@/gql/graphql";

const routeAgreementsRatesByFilterQuery = gql`
  fragment RouteAgreementForRouteAgreementPrice on RouteAgreement {
    id
    agreementNumber
    routes {
      id
      routePair {
        id
        code
        description
      }
    }
    name
    valid {
      start {
        isoString
      }
      end {
        isoString
      }
    }
    currency {
      id
      code
    }
    prices {
      avgRebate {
        amount
      }
    }
    isSalesReady
    rowVersion
    sailingTypeCodes
    statusCode
    routeDescription
  }

  fragment VehicleTypeForAgrRoutePrices on VehicleType {
    id
    code
    name
    shortDescription
    accompanied
  }
  fragment ItemByRoutePairCodesForCustomers on CustomerStatisticsEntry {
    id
    expectedVolume
    statVolume12Months
    unitCategoryCode
    expectedStatVolume
    routePairCode
    volume12Months
    actualOutcomeInPercent
    targetInPercent
    sailingCategoryCode
  }

  fragment AgreementRoutePrices on RouteAgreementPrice {
    id
    lengthFrom
    lengthTo
    weightFrom
    weightTo
    cargoStatusCode
    unaccompanied
    vehicleType {
      ...VehicleTypeForAgrRoutePrices
    }
    avgGrossPrice {
      amount
    }
    avgLength
    lastPrice {
      amount
    }
    meterPrice {
      amount
    }
    lastChargedFrom
    newPrice {
      amount
    }
    meterPrice {
      amount
    }
    lastMeterPrice {
      amount
    }
    avgRebate {
      amount
    }
    volume
    additionalFrom
    actual
    routeAgreement {
      ...RouteAgreementForRouteAgreementPrice
    }
  }
  query RouteAgreementsRatesByFilter(
    $byFilterInput: RouteAgreementPricesByFilterInput!
    $routePairCodes: [String!]
    $year: Int!
    $customerId: ID!
  ) {
    productPrice {
      customers {
        byId(id: $customerId) {
          id
          statisticsByRoutePairCodes(
            year: $year
            routePairCodes: $routePairCodes
          ) {
            itemsByRoutePairCodes {
              ...ItemByRoutePairCodesForCustomers
            }
          }
        }
      }
      routeAgreementPrice {
        byFilter(input: $byFilterInput) {
          numberOfAgrRouteRates
          agrRoutePrices {
            ...AgreementRoutePrices
          }
        }
      }
    }
  }
`;

export const useRouteAgreementsRatesByFilterQuery = () => {
  const [fetchRouteAgreementsByFilter, { data, loading, error, refetch }] =
    useLazyQuery<
      RouteAgreementsRatesByFilterQuery,
      RouteAgreementsRatesByFilterQueryVariables
    >(routeAgreementsRatesByFilterQuery, {
      fetchPolicy: "network-only",
      notifyOnNetworkStatusChange: true,
      nextFetchPolicy: "cache-first",
    });
  const routeAgreementRates = data;

  return {
    routeAgreementRates,
    refetch,
    loading,
    error,
    fetchRouteAgreementsByFilter,
  };
};
